<template>
  <div></div>
</template>

<script>
const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
const recognition = SpeechRecognition ? new SpeechRecognition() : false;

export default {
  name: 'SpeechToText',

  props: {
    lang: {
      type: String,
      default: 'en-US',
    },
    text: {
      type: [String, null],
      default: '',
      required: true,
    },
    toggle: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      error: false,
      speaking: true,
      runtimeTranscriptions: {
        text: '',
        startTime: '',
        endTime: '',
      },
      sentences: [],
    };
  },

  methods: {
    changeTime(time) {
      let newTime = time;
      const milliseconds = this.addZeroPadding(newTime % 1000, 3);
      newTime = Math.floor(newTime / 1000);
      const seconds = this.addZeroPadding(newTime % 60);
      newTime = Math.floor(newTime / 60);
      const minutes = this.addZeroPadding(newTime % 60);
      newTime = Math.floor(newTime / 60);
      const hours = this.addZeroPadding(newTime % 24);

      return `${hours}:${minutes}:${seconds}.${milliseconds}`;
    },

    addZeroPadding(time, pad = 2) {
      return (`${time}`).padStart(pad, '0');
    },

    checkCompatibility() {
      if (!recognition) {
        this.error = 'Speech Recognition is not available on this browser. Please use Chrome or Firefox';
      }
    },

    endSpeechRecognition() {
      console.log('Speech Recognition Ended here');
      recognition.stop();
      this.toggle = false;
      this.$emit('speechend', {
        sentences: this.sentences,
        text: this.sentences.join('. '),
      });
      this.$store.dispatch('screenRecordCaption', this.sentences).then(() => {
        this.sentences = [];
      });
    },

    // eslint-disable-next-line consistent-return
    startSpeechRecognition() {
      const zeroTime = new Date();

      console.log(`Started at ${zeroTime}`);
      if (!recognition) {
        this.error = 'Speech Recognition is not available on this browser. Please use Chrome or Firefox';
        return false;
      }
      this.toggle = true;
      recognition.lang = this.lang;
      recognition.interimResults = true;

      recognition.addEventListener('speechstart', () => {
        this.runtimeTranscriptions.startTime = this.changeTime(new Date() - zeroTime);
        this.speaking = true;
      });

      recognition.addEventListener('speechend', () => {
        this.runtimeTranscriptions.endTime = this.changeTime(new Date() - zeroTime);
        this.speaking = false;
      });

      recognition.addEventListener('result', (event) => {
        const text = Array.from(event.results).map((result) => result[0]).map((result) => result.transcript).join('');
        console.log(text);
        this.runtimeTranscriptions.text = text;
      });

      recognition.addEventListener('end', () => {
        if (this.runtimeTranscriptions.text !== '') {
          const capitalizedSentence = this.capitalizeFirstLetter(this.runtimeTranscriptions.text);
          this.sentences.push({
            sentence: capitalizedSentence,
            startTime: this.runtimeTranscriptions.startTime,
            endTime: this.runtimeTranscriptions.endTime,
          });
          this.$emit('update:text', `${this.text}${this.sentences.slice(-1)[0]}. `);
        }
        this.runtimeTranscriptions = {
          text: '',
          startTime: '',
          endTime: '',
        };
        recognition.stop();
        if (this.toggle) {
          // keep it going.
          recognition.start();
        }
      });
      recognition.start();
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },

  watch: {
    toggle(newValue) {
      if (newValue) {
        this.startSpeechRecognition();
      } else {
        this.endSpeechRecognition();
      }
    },
  },
};
</script>
